<template>
  <div class="page">
    <BookingBack title="Email" :textColor="'#333333'" :isCenter="true" />
    <div class="content">
      <van-field v-model="email" placeholder="Please enter email" clearable type="text" />
    </div>
    <div class="footer">
      <van-button block color="#1E3C3E" :loading="saving" @click="save">Save</van-button>
    </div>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { getUserDetail, updateUserInfo } from '@/api'
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export default {
  name: 'AccountEmail',
  components: { BookingBack },
  data() {
    return { email: '', user: {}, saving: false }
  },
  created() {
    const q = this.$route.query || {}
    this.email = q.email || ''
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const res = await getUserDetail()
        if (res && res.code === 1 && res.data && res.data.userInfo) {
          this.user = res.data.userInfo
          if (!this.email) {
            this.email = this.user.email || ''
          }
        }
      } catch (e) {}
    },
    async save() {
      const email = (this.email || '').trim()
      if (!email) {
        this.$toast && this.$toast('Please enter email')
        return
      }
      if (!EMAIL_REGEX.test(email)) {
        this.$toast && this.$toast('Please enter a valid email')
        return
      }
      this.saving = true
      try {
        const res = await updateUserInfo({
          email,
          nickName: this.user.nickName || '',
          avatarUrl: this.user.avatarUrl || ''
        })
        if (res && res.code === 1) {
          this.$toast && this.$toast.success('Saved')
          this.$router.go(-1)
        } else {
          this.$toast && this.$toast.fail((res && res.msg) || 'Update failed')
        }
      } catch (e) {
        this.$toast && this.$toast.fail('Update failed')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page { min-height: 100vh; background: #f5f7fa; }
.content { padding: 1rem; }
.footer { position: fixed; left: 0; right: 0; bottom: 1rem; padding: 0 1rem; }
</style>
